import ProductsSearchView from "../../../../components/Products/ProductsSearchView.vue";

export default { path: '/zoekresultaten', name: 'ProductsSearch', component: ProductsSearchView };
